import { render, staticRenderFns } from "./CustomerDocumentDetail.vue?vue&type=template&id=71c75d3f"
import script from "./CustomerDocumentDetail.vue?vue&type=script&lang=js"
export * from "./CustomerDocumentDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports